import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type SocietyProfileInvoiceInvoiceItemDiscountCodeParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/accounting/invoice/[invoiceId]/item/[invoiceItemId]/discountCode/[discountCodeString]";
import { type InvoiceView } from "shared/mappers/database/accounting/invoice/invoice";
export const postSocietyProfileAccountingInvoiceItemDiscountCodeStringContract: BaseApiContract<
  SocietyProfileInvoiceInvoiceItemDiscountCodeParamsInput,
  undefined,
  InvoiceView
> = {
  method: HttpMethod.POST,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/accounting/invoice/[invoiceId]/item/[invoiceItemId]/discountCode/[discountCodeString]",
  paramsType: {} as SocietyProfileInvoiceInvoiceItemDiscountCodeParamsInput,
  responseType: {} as InvoiceView,
};
